import { AllocationsTable } from "features/allocations/AllocationsTable";
import { EntityEditTabContext } from "features/entities/edit/EntityEditTabContext";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const EntityEditTabAllocations: React.FC = () => {
  const { fundFamilyId, entity } = useOutletContext<EntityEditTabContext>();
  return (
    <PageTabBody>
      {/* TODO: This tab is disabled in EntityEditRoutes if a fundFamilyId is not available,
           so type assertion is safe. Remove when global allocation rules are supported. */}
      <AllocationsTable
        fundFamilyId={fundFamilyId!}
        params={{
          entity_id: entity.id!,
        }}
      />
    </PageTabBody>
  );
};
